import { render, staticRenderFns } from "./Manage-trademarks.vue?vue&type=template&id=2b977f02&scoped=true&"
import script from "./Manage-trademarks.vue?vue&type=script&lang=js&"
export * from "./Manage-trademarks.vue?vue&type=script&lang=js&"
import style0 from "./Manage-trademarks.vue?vue&type=style&index=0&id=2b977f02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b977f02",
  null
  
)

export default component.exports